import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, map, Observable, of } from 'rxjs';
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  private http = inject(HttpClient);
  private globalsService = inject(GlobalsService);
  public page: WritableSignal<number> = signal(1);
  public articlesPerPage: WritableSignal<number> = signal(19);
  public articles: WritableSignal<number[]> = signal([]);
  public articlesCount: WritableSignal<number> = signal(0);
  public loading: WritableSignal<boolean> = signal(true);

  loadList(page: number, type: 'reviews' | 'default'): Observable<any> {
    const typeParam = type === 'reviews' ? '&filters[category][$eq]=reviews' : '';
    return this.http.get<any>(`https://admin.mototechna.cz/api/blogs?pLevel&pagination[page]=${page}&pagination[pageSize]=${this.articlesPerPage()}&sort=createdAt:desc${typeParam}`, {}).pipe(
      map((response) => {
        this.page.set(page);
        response.type = type;
        response.data.forEach((article: any) => {
          article.url = this.globalsService.removeDiacritics(article.title);
        });
        this.articlesCount.set(response?.meta?.pagination?.total || 0);
        this.loading.set(false);
        return response;
      }),
    );
  }

  loadArticle(id: number): Observable<any> {
    return this.http.get<any>(`https://admin.mototechna.cz/api/blogs/${id}?pLevel`, {}).pipe(
      map((response) => {
        response.data.url = this.globalsService.removeDiacritics(response.data.title);
        response.data.content?.forEach((content: any) => {
          if (content.image) {
            content.image.halfWidth = Math.round(content.image.width / 2);
            content.image.halfHeight = Math.round(content.image.height / 2);
          }
        });
        return response;
      }),
      catchError(() => {
        return of(undefined)
      })
    );
  }
}
